export type DownloadCSVAPIError =
  'tooManyOrders' |
  'missingDate' |
  'noOrders' |
  'noOrdersRoute' |
  'projectIdNotFound' |
  'downloadFailed' |
  'tooManyRequests' |
  'default';

export enum APIErrorEnum {
  TOO_MANY_ORDERS,
  MISSING_DATE,
  NO_ORDERS,
  PROJECT_ID_NOT_FOUND,
  DOWNLOAD_FAILED,
}
